import { FC, useEffect } from 'react';
import { useStyles } from './styles';
import { RecoveryRequestForm } from 'components/Forms';
import EndUserHeader from 'components/Headers/EndUserHeader/EndUserHeader';
import Easy from '../../assets/easyidentity.jpg';
import { useStore } from 'hooks/useRootStore';
import EndUserFooter from 'components/Headers/EndUserFooter/EndUserFooter';
import { useQuery } from 'react-query';
import { useAppPreloader } from 'hooks/useAppPreloader';

const UserIdRecovery: FC = () => {
  const classes = useStyles();
  useEffect(() => {
    document.title = 'EasyIdentity: User Forgot Id';
  }, []);

  const {
    endUserSettingsFormStore: { getPortalSettings, endUserConfigSettings },
    notificationStore: { openNotification },
  } = useStore();
  const portalSettingsgetReq = useQuery('portalSettingsgetReq', () => getPortalSettings(), {
    onError: () => openNotification('error', `Can't get data`),
  });
  useAppPreloader(portalSettingsgetReq.isLoading);

  const bodyStyle = {
    backgroundImage: `url(${endUserConfigSettings?.bannerImage || Easy})`,
    backgroundSize: 'cover',
    backgroundAttachment: 'fixed',
  };
  return (
    <div className={classes.container} style={bodyStyle}>
      <div>
        <EndUserHeader />
      </div>
      <RecoveryRequestForm type='end-user-recovery-id' title='Recovery User ID' />
      {/* <div className={classes.footer}>
        <p>Copyright 2022 9STAR, All Rights Reserved. Version 0.1.39</p>
      </div> */}
      <EndUserFooter />
    </div>
  );
};
export default UserIdRecovery;
